module.exports = __webpack_public_path__ + "img/901-9da1ea.png";